import React, { Component } from "react";
import { Table } from "react-bootstrap";
import { isValidArray } from "../../../helper";
import NoDataFound from "../../../component/NoDataFound";
import { LoaderTemplate as DefaultLoader } from "./loaderTemplate";
import {
  pmgInvestSortOrderAction,
  sectionSortOrderAction,
  dpiitSortOrderAction
} from "../../../actions/pmgTeam.action";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { RemoveFromQueue } from "@material-ui/icons";

class PmgTableTemplate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      bodyOptions: [],
      calledFrom: props.calledFrom,
      //drag & drop
      isDragging: false
    };
  }

  //drag & drop
  handleDragStart = results => {
    this.setState({ isDragging: true });
  };

  handleDragEnd = async result => {
    // console.log("result----", result);
    if (!result.destination) {
      //console.log("in if");
      return;
    }

    //console.log("before", this.state.bodyOptions);
    const { bodyOptions } = this.state;
    const updatedBodyOptions = [...bodyOptions];
    //console.log("updatedBodyOptions", updatedBodyOptions);
    const [reorderedItem] = updatedBodyOptions.splice(result.source.index, 1);
    [reorderedItem][0].displayOrder = result.destination.index + 1;
    updatedBodyOptions.splice(result.destination.index, 0, reorderedItem);
    const newData = updatedBodyOptions.map((item, i) => {
      const imageId = [];
      if (item.image[0].id !== null) {
        imageId.push(item.image[0].id);
      }
      return {
        ...item,
        displayOrder: i + 1,
        image: imageId
      };
    });
    // console.log(newData, "newData");
    let validSwap = true;
    //console.log(newData, "newData");
    //let swapedData = [];

    for (let i = 0; i < newData.length - 1; i++) {
      if (newData[i].priority > newData[i + 1].priority) {
        validSwap = false;
        break;
      }
    }
    //console.log("validSwap", validSwap);
    // if (validSwap) {
    this.setState({ bodyOptions: updatedBodyOptions }, () => {
      this.props.onReorder(this.state.bodyOptions);
    });
    if (this.state.calledFrom == "PMG") {
      let data = await pmgInvestSortOrderAction(newData);
      //console.log("after", this.state.bodyOptions, data);
    } else if (this.state.calledFrom == "SEC") {
      let data = await sectionSortOrderAction(newData);
      //console.log("after", this.state.bodyOptions, data);
    } else {
      let data = await dpiitSortOrderAction(newData);
      //console.log("after", this.state.bodyOptions, data);
    }
    //}
  };
  componentDidMount() {
    //console.log("hii", this.props.bodyOptions && this.props.bodyOptions);
    if (this.props.bodyOptions)
      this.setState({
        bodyOptions: this.props.bodyOptions && this.props.bodyOptions
      });
  }
  componentDidUpdate(prevState) {
    if (prevState.bodyOptions !== this.props.bodyOptions) {
      this.setState({
        bodyOptions: this.props.bodyOptions && this.props.bodyOptions
      });
    }
  }

  render() {
    const {
      isBestPracticesTable = false,
      isPmgTable,
      isLoading = false,
      LoaderTemplate = DefaultLoader,
      headersOptions = [],
      headersTemplate,
      tableOptions = {},
      classes = "",
      bodyTemplate,
      checkboxLoader
    } = this.props;
    //console.log("from templet", this.props);
    const { bodyOptions } = this.state;
    return (
      <>
        {/*<DragDropContext*/}
        {/*  onDragEnd={this.handleDragEnd}*/}
        {/*  //drag & drop*/}
        {/*  onDragStart={results => this.handleDragStart(results)}*/}
        {/*>*/}
        {/*  <Table*/}
        {/*    responsive*/}
        {/*    striped*/}
        {/*    hover*/}
        {/*    size="sm"*/}
        {/*    {...tableOptions}*/}
        {/*    className={` ${*/}
        {/*      isBestPracticesTable*/}
        {/*        ? "best-practices-container-cms"*/}
        {/*        : "admin-table-container-cms"*/}
        {/*    } ${classes} ${isPmgTable === true ? "pmg-table" : ""}`}*/}
        {/*  >*/}
        {/*    <thead*/}
        {/*      className={`no-sort-icon ${*/}
        {/*        isPmgTable === true ? "pmg-table-header" : ""*/}
        {/*      }`}*/}
        {/*    >*/}
        {/*      <tr className={`${isPmgTable === true ? "pmg-table" : ""}`}>*/}
        {/*        {headersOptions.map((value, index) => {*/}
        {/*          return headersTemplate ? headersTemplate(value, index) : null;*/}
        {/*        })}*/}
        {/*      </tr>*/}
        {/*    </thead>*/}

        {/*    <Droppable droppableId="droppable">*/}
        {/*      {provided => (*/}
        {/*        <tbody*/}
        {/*          {...provided.droppableProps}*/}
        {/*          ref={provided.innerRef}*/}
        {/*          className={`${isPmgTable === true ? "users-table-body" : ""}`}*/}
        {/*        >*/}
        {/*          {console.log("LoaderTemplate", LoaderTemplate)}*/}
        {/*          {isLoading ? (*/}
        {/*            LoaderTemplate ? (*/}
        {/*              <tr align="center" className="table-loader">*/}
        {/*                <td colSpan={headersOptions.length}>*/}
        {/*                  <LoaderTemplate />*/}
        {/*                </td>*/}
        {/*              </tr>*/}
        {/*            ) : (*/}
        {/*              <tr align="center">*/}
        {/*                <td colSpan={headersOptions.length}>Loading...</td>*/}
        {/*              </tr>*/}
        {/*            )*/}
        {/*          ) : isValidArray(bodyOptions) ? (*/}
        {/*            bodyOptions.map((value, index) => (*/}
        {/*              <Draggable*/}
        {/*                key={value.id}*/}
        {/*                draggableId={`draggable-${value.id}`}*/}
        {/*                index={index}*/}
        {/*              >*/}
        {/*                {provided => (*/}
        {/*                  <tr*/}
        {/*                    ref={provided.innerRef}*/}
        {/*                    {...provided.draggableProps}*/}
        {/*                    {...provided.dragHandleProps}*/}
        {/*                    //drag & drop*/}
        {/*                    className={*/}
        {/*                      this.state.isDragging ? "draggable-row" : null*/}
        {/*                    }*/}
        {/*                  >*/}
        {/*                    {bodyTemplate ? bodyTemplate(value, index) : null}*/}
        {/*                  </tr>*/}
        {/*                )}*/}
        {/*              </Draggable>*/}
        {/*            ))*/}
        {/*          ) : (*/}
        {/*            <tr align="center">*/}
        {/*              <td colSpan={headersOptions.length}>*/}
        {/*                <NoDataFound />*/}
        {/*              </td>*/}
        {/*            </tr>*/}
        {/*          )}*/}
        {/*          {provided.placeholder}*/}
        {/*        </tbody>*/}
        {/*      )}*/}
        {/*    </Droppable>*/}
        {/*  </Table>*/}
        {/*</DragDropContext>*/}

        <DragDropContext onDragEnd={this.handleDragEnd}>
          <Droppable droppableId="droppable">
            {provided => (
              <div
                style={{
                  boxShadow: "0px 0px 8px rgba(0, 0, 0, 0.25)",
                  borderRadius: "4px"
                }}
              >
                <table
                  {...provided.droppableProps}
                  ref={provided.innerRef}
                  className={
                    " admin-table-container-cms  pmg-table table table-sm table-striped table-hover "
                  }
                  //style={{filter: "drop-shadow(0px 0px 8px rgba(0, 0, 0, 0.25))"}}
                >
                  <thead
                    className={`no-sort-icon ${
                      isPmgTable === true ? "pmg-table-header" : ""
                    }`}
                  >
                    <tr className={`${isPmgTable === true ? "pmg-table" : ""}`}>
                      {headersOptions.map((value, index) => {
                        return headersTemplate
                          ? headersTemplate(value, index)
                          : null;
                      })}
                    </tr>
                  </thead>
                  <tbody className={"users-table-body"}>
                    {checkboxLoader ? (
                      checkboxLoader ? (
                        <tr align="center" className="table-loader">
                          <td colSpan={headersOptions.length}>
                            <LoaderTemplate />
                          </td>
                        </tr>
                      ) : (
                        <tr align="center">
                          <td colSpan={headersOptions.length}>Loading...</td>
                        </tr>
                      )
                    ) : isValidArray(bodyOptions) ? (
                      bodyOptions.map((item, index) => (
                        <Draggable
                          key={item.name + item.id}
                          draggableId={item.name + item.id}
                          index={index}
                        >
                          {provided => (
                            <tr
                              ref={provided.innerRef}
                              {...provided.draggableProps}
                              {...provided.dragHandleProps}
                            >
                              {bodyTemplate ? bodyTemplate(item, index) : null}
                            </tr>
                          )}
                        </Draggable>
                      ))
                    ) : (
                      <tr align="center">
                        <td colSpan={headersOptions.length}>
                          <NoDataFound />
                        </td>
                      </tr>
                    )}

                    {provided.placeholder}
                  </tbody>
                </table>
              </div>
            )}
          </Droppable>
        </DragDropContext>
      </>
    );
  }
}

export { PmgTableTemplate };
